import { BaseListRepository } from 'core/classes';
import { Company } from '../interfaces';
import { companyResource } from '../resources/CompanyResource';

class CompanyRepository extends BaseListRepository<Company> {}

export const companyRepository = new CompanyRepository(companyResource);
